<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30 font-sans"
        >
            <div class="relative shadow-md rounded overflow-hidden w-11/12 sm:w-[370px]">
                <button
                    @click="emitClose"
                    type="button"
                    aria-label="close modal"
                    class="absolute top-4 right-4"
                >
                    <img
                        src="../assets/images/icons/close-white.svg"
                        width="20"
                        height="20"
                        alt="X"
                    >
                </button>

                <div
                    :class="[ padding[paddingSize], { 'border-b border-black': showBorder } ]"
                    :style="{ backgroundImage: `url(${modalImage})` }"
                    class="min-h-[150px] bg-gray-light bg-cover bg-center bg-no-repeat"
                >
                    <slot name="header" />
                </div>

                <div
                    :class="padding[paddingSize]"
                    class="bg-white"
                >
                    <slot name="content" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            paddingSize: {
                type: String,
                default: 'small',
            },
            showBorder: {
                type: Boolean,
                default: false,
            },
            modalImage: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                padding: {
                    small: 'p-5',
                    large: 'p-8 sm:px-12',
                },
            };
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>
